// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FYV2c","container":"styles_container__5GoXx"};